import React, { useEffect, useState } from "react";
import { Row, Col, Modal, Form, Button, Dropdown } from "react-bootstrap";
import { BsCalendar } from "react-icons/bs";
import { FaMobileAlt } from "react-icons/fa";
import { ImLocation } from "react-icons/im";
import Logo from "../../Assets/images/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { showwishlist } from "../../Reducer/wishlistReducer";
import { showcartlist } from "../../Reducer/cartReducer";
import { showaccount } from "../../Reducer/homeReducer";
import { ToastContainer } from "react-toastify";
import QuickSearchmain from "./QuickSearchmain";
const Top_header = (props) => {
    const topHeader = useSelector(state => state.persistedReducer?.home?.topHeader);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation()

    const home = useSelector(state => state?.persistedReducer?.home);
    const wishlist = useSelector((state) => state.persistedReducer.wish);
    const cart = useSelector((state) => state.persistedReducer.cart);
    const [isSearchbox, isSetsearchbox] = useState(false);
    const [search, setSearch] = useState("");

    // window.woopra.config({
    //     domain: "weddingdaydiamonds.com",
    //     outgoing_tracking: true,
    //     download_tracking: true,
    //     click_tracking: true
    //   });

    //   window.woopra.identify({
    //     search: search
    //   });

    // window.woopra.track();

    return (
        <>
            <ToastContainer />


            <section className="top_header">

                {
                    props.width > 992 ?


                        topHeader?.grid_type === "double" ? <Row>
                            <Col md={6} className="p-0">
                                <div className="top_header_box bg_primary text-center mobile_hide" style={{ background: topHeader?.backgroundColor_1 }}>
                                    <Link to={topHeader?.text_url_1} style={{fontSize: `${topHeader?.font_size}px` , color: topHeader?.text_color_1, fontFamily: topHeader?.font }}>
                                        {
                                            topHeader?.icon_1 && <img style={{ width: "10px", marginRight: "6px" }} src={topHeader?.icon_1} alt={topHeader?.text_1} />
                                        }

                                        {topHeader?.text_1 && topHeader?.text_1}</Link>
                                </div>
                            </Col>
                            <Col md={6} className="p-0">
                                <div className="top_header_box bg_secondary text-center mobile_hide" style={{ background: topHeader?.backgroundColor_2 }}>
                                    <Link to={topHeader?.text_url_2} style={{fontSize: `${topHeader?.font_size}px`, color: topHeader?.text_color_2, fontFamily: topHeader?.font }}>
                                        {
                                            topHeader?.icon_2 && <img style={{ width: "10px", marginRight: "6px" }} src={topHeader?.icon_2} alt={topHeader?.text_2} />
                                        }
                                        {topHeader?.text_2 && topHeader?.text_2}</Link>
                                </div>

                            </Col>
                        </Row> : <div className="text-center colorWhite py-2 ls3 topOfferMsg " style={{ background: topHeader?.backgroundColor_1, fontSize: topHeader?.font_size, color: topHeader?.text_color_1, fontFamily: topHeader?.font }}>
                            <Link to={topHeader?.text_url_1} style={{fontSize: `${topHeader?.font_size}px`, color: topHeader?.text_color_1, fontFamily: topHeader?.font }}>
                                {
                                    topHeader?.icon_1 && <img style={{ width: "10px", marginRight: "6px", marginLeft: "6px" }} src={topHeader?.icon_1} alt={topHeader?.text_1} />
                                }
                                {topHeader?.text_1 && topHeader?.text_1}
                                {/* {topHeader?.text_2 && topHeader?.text_2}
                    {
                        topHeader?.icon_2 && <img style={{ width: "10px", marginRight: "6px", marginLeft: "6px" }} src={topHeader?.icon_2} alt={topHeader?.text_2} />
                    } */}

                            </Link>
                        </div>

                        : <div className="greenBg text-center colorWhite py-2 ls3 topOfferMsg fs13 marquee-container" style={{ background: topHeader?.backgroundColor_1, color: topHeader?.text_color_1, fontFamily: topHeader?.font }}>
                            <div className="marquee">
                                <Link to={topHeader?.text_url_1} style={{fontSize: `${Number(topHeader?.font_size) - 2}px`,color: topHeader?.text_color_1, fontFamily: topHeader?.font }}>
                                    {
                                        topHeader?.icon_1 && <img style={{ width: "10px", marginRight: "6px", marginLeft: "6px" }} src={topHeader?.icon_1} alt={topHeader?.text_1} />
                                    }
                                    {topHeader?.text_1 && topHeader?.text_1} |  {topHeader?.text_2 && topHeader?.text_2}
                                    {
                                        topHeader?.icon_2 && <img style={{ width: "10px", marginRight: "6px", marginLeft: "6px" }} src={topHeader?.icon_2} alt={topHeader?.text_2} />
                                    }
                                </Link>


                            </div>

                        </div>
                }


                <div className="top_links">
                    <div className="top_header_container">
                        <Row>
                            <Col md={6}>
                                <div className="top_links_box mobile_hide">
                                    <ul>
                                        <li>
                                            <Link to="tel:1-866-740-7464">
                                                <FaMobileAlt />
                                                1-866-740-RING
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/showroom">
                                                <ImLocation />
                                                FIND A SHOWROOM
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/book-an-appointment" className="text-uppercase">
                                                <BsCalendar />
                                                Book an Appointment
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="top_icon_box text-end mobile_hide">
                                    <ul>
                                        <li className="mobile_hide position-relative">
                                            {/* klevu  */}
                                            <QuickSearchmain enablePersonalisation currentUrl={location.pathname} onProductClick={(p) => {
                                                console.log('ppp1', p);
                                                navigate("/product-detail/" + p?.itemGroupId + "/" + p?.slug)
                                                // comment line above and uncomment this to test full page reload. For testing analytical events caching
                                                // window.location.href = `http://localhost:3001/products/${p.itemGroupId}/${p.id}`
                                            }}
                                            // onSearchClick={(q) => {
                                            //     navigate(`/search?q=${encodeURIComponent(q)}`)
                                            //   }}
                                            />
                                        </li>
                                        <li className="mobile_hide">
                                            <div className="Login_dropdown_form">
                                                <span
                                                    className="header-icon account"
                                                    onClick={() => {
                                                        dispatch(showwishlist(false));
                                                        dispatch(showcartlist(false));
                                                        dispatch(showaccount(!home?.showaccount));
                                                    }}
                                                ></span>
                                            </div>
                                        </li>

                                        <li className="mobile_hide">
                                            <div className="cart_dropdown_top wishlist_dropdown_top">
                                                <div
                                                    onClick={() => {
                                                        dispatch(showwishlist(!wishlist?.show));
                                                        dispatch(showcartlist(false));
                                                        dispatch(showaccount(false));
                                                    }}
                                                >
                                                    <span className="header-icon wishlist"></span>
                                                    {wishlist?.wishlistlength ? (
                                                        <span className="wish_item_count">
                                                            {wishlist?.wishlistlength}
                                                        </span>
                                                    ) : (
                                                        ""
                                                    )}
                                                </div>
                                            </div>
                                        </li>
                                        <li className="desktop_hide">
                                            <Link to="#">
                                                <span className="header-icon search"></span>
                                            </Link>
                                        </li>
                                        <li>
                                            <div className="cart_dropdown_top">
                                                <div
                                                    onClick={() => {
                                                        dispatch(showcartlist(!cart?.show));
                                                        dispatch(showwishlist(false));
                                                        dispatch(showaccount(false));
                                                    }}
                                                >
                                                    <span className="header-icon cart"></span>
                                                    {cart?.cartlengthvalue ? (
                                                        <span className="cart_item_count">
                                                            {cart?.cartlengthvalue}
                                                        </span>
                                                    ) : (
                                                        <span className="cart_item_count">
                                                            0
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="brand-name text-center mobile_hide">
                    <Link to="/">
                        <img src={Logo} alt="Wedding Days Diamond" />
                    </Link>
                </div>
            </section>

            {/* <Modal show={show} onHide={handleClose} className="mobile-search-box">
        <form className="d-flex justify-content-center">
          <input
            className="search-mobile-field"
            type="text"
            placeholder="Search here"
          />
          <input
            className="search-mobile-field-btn"
            type="submit"
            value="Submit"
          />
        </form>
      </Modal> */}

            {/* <Modal className='wishlist-modal-top' backdropClassName='wishlist-backdrop' show={wishlist?.show} onHide={()=> dispatch(showwishlist(!wishlist?.show))}><div className='wishlist_dropdown wishlist_dropdown_top cart_dropdown_top'><Wishlist popup={true} /></div></Modal>

            <Modal className='wishlist-modal-top' backdropClassName='wishlist-backdrop' show={cart?.show} onHide={()=> dispatch(showcartlist(!cart?.show))}><div className='wishlist_dropdown wishlist_dropdown_top cart_dropdown_top'><Cart popup={true} /></div> </Modal> */}

            {/* Login Modal */}
            {/* <Modal className='wishlist-modal-top' backdropClassName='wishlist-backdrop' show={loginshow} onHide={loginhandleClose}>
                <div className='Login_dropdown_form'>
                    <div className='dropdown_menu_box'>
                        {
                            selector?.isLogin ? <div>
                                <h1 className="title">Hi, {selector?.user.first_name+ " " + selector?.user.last_name}</h1>
                                <h4 className="sub-title">My Account</h4>
                                <ul>
                                    <li>
                                        <Link to="/">Account Dashboard</Link>
                                    </li>
                                    <li>
                                        <Link to="/">Order History</Link>
                                    </li>
                                    <li>
                                        <Link to="/wishlist">Wish List</Link>
                                    </li>
                                </ul>

                                <Button onClick={() => logout()} className='theme_btn login_btn'>
                                    Sign Out
                                </Button>
                            </div> :
                                <>
                                    <LoginAction />
                                    <p>Don't have an account? <br /> Create One !</p>
                                    <Link className='theme_btn login_btn' to='/login' onClick={() => setloginShow(false)}>Create Account</Link>
                                </>


                        }


                    </div>
                </div>
            </Modal> */}



        </>
    );
};

export default Top_header;
